import { createContext, forwardRef, useContext } from 'react'
import { Card, CardBody, CardHeader, Progress } from '@chakra-ui/react'
import PropTypes from 'prop-types'

const UiCardContext = createContext()

// eslint-disable-next-line react/display-name
export const UiCard = forwardRef(
  ({ isLoading, children, ...rest }, ref) => {
    return (
        <Card ref={ref} {...rest}>
          <UiCardContext.Provider value={{ isLoading }}>
            {children}
          </UiCardContext.Provider>
        </Card>
    )
  }
)

UiCard.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node
}

export const UiCardHeader = ({ children, ...rest }) => {
  return (
    <CardHeader {...rest}>
      {children}
    </CardHeader>
  )
}

UiCardHeader.propTypes = {
  children: PropTypes.node
}

export const UiCardBody = ({ children, ...rest }) => {
  const { isLoading } = useContext(UiCardContext)
  return (
    <>
      {isLoading && (
        <Progress
          size='xs'
          isIndeterminate
        />
      )}
      <CardBody {...rest}>
        {children}
      </CardBody>
    </>
  )
}

UiCardBody.propTypes = {
  children: PropTypes.node
}
